<script>
    // Stores 
    import { 
        textSite,
        mailLista
        
    } from '../store.js'; 
    
	// Componentes
    import { Router, Link, link , Route } from "svelte-routing";
    import Forms from "../components/Forms.svelte";  
    import PageHeader from './../components/PageHeader.svelte';

    // Code
    let titlePage = 'Favoritos - ' + $textSite;

    let fields = [
        {
            title:  'Nome *',
            name:   'nome',
            required:   'required'
        },
        {
            title:  'Telefone *',
            name:   'telefone',
            required: 'required',
        },
        {
            title:  'Email *',
            name:   'email',
            type: 'email',
            required: 'required',
        },
        {
            title:             'Mensagem *',
            name:              'mensagem',
            defaultValue:      'Solicito contato sobre a lista de imoveis selecionados.',
            required:          'required',
            type:              'textarea',
            rows: 4
        }
    ];

    //Carrega bookmarks
    atria.loadBookmarks();
    
    const message = `Nome: {nome}<br />
Telefone: {telefone}<br />
Email: {email}<br />
Mensagem: {mensagem}<br />
Lista: <a href="${atria.mainURL}/favoritos#bookmarks=${EncodeBase64(window.store.get('bookmarks'))}" target="_blank">Clique Aqui</a><br /><br />
{info}`;
</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container">
        <div class="row">        
            <div class="col-md-5 d-md-none">
                <p>Envie sua lista de imóveis selecionados para a {$textSite}. Entraremos em contato com maiores informações sobre os imóveis.</p>
            </div>        
            <div class="col-md-5 offset-md-1">       
                <Forms fields={fields} subject="Favoritos - Enviar para {$textSite} | {$textSite}"  {message} htmlbody={true} destiny={$mailLista} />
            </div>
            <div class="col-md-5 d-none d-md-block">
                <p class="text-right mt-20">Envie sua lista de imóveis selecionados para a {$textSite}. Entraremos em contato com maiores informações sobre os imóveis.</p>
            </div>
        </div>
    </div>
</section>